class ArrowIndicator extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.handleClick);
    this.updateArrowState();
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
  }

  handleClick = (evt) => {    
    const scrollContainer = this.closest('.product-variant-picker-color').querySelector('.category-products');

    this.updateArrowState();

    if (this.classList.contains('custom-scroll-previous')) {
      scrollContainer.scrollBy({
        left: -60,
        behavior: 'smooth'
      });
    }

    if (this.classList.contains('custom-scroll-next')) {
      scrollContainer.scrollBy({
        left: 60,
        behavior: 'smooth'
      });
    }

    setTimeout(() => {
      this.updateArrowState();
    }, 300);
  };

  updateArrowState() {
    const scrollContainer = this.closest('.product-variant-picker-color').querySelector('.category-products');
    const scrollLeft = scrollContainer.scrollLeft;
    const scrollWidth = scrollContainer.scrollWidth;
    const clientWidth = scrollContainer.clientWidth;

    const leftArrow = this.closest('.product-variant-picker-color').querySelector('.custom-scroll-previous');
    const rightArrow = this.closest('.product-variant-picker-color').querySelector('.custom-scroll-next');

    if (scrollLeft === 0) {
      leftArrow.classList.add('disabled');
    } else {
      leftArrow.classList.remove('disabled');
    }

    if (scrollLeft + clientWidth >= scrollWidth) {
      rightArrow.classList.add('disabled');
    } else {
      rightArrow.classList.remove('disabled');
    }
  }
}

customElements.define('arrow-indicator', ArrowIndicator);
